<template lang="pug">
transition.entity(tag="div", appear, name="fade", v-if="instance")
  component(
    v-if="!!$replasable(entity.name, parent) && replasable",
    :is="$replasable(entity.name, parent)",
    v-bind="{ ...$attrs, chips, selector, path, parentPath, invert, relation, entity, parent, fromList, parentInstance, elementIndex, extraData, isActive, modalInstance }",
    @field-input="input($event.value, $event.field)",
    v-on="$listeners",
  )
  .entity-content.pa-5(v-else)
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ getLabel.replace(/_/g, " ") }}
        g-btn.ml-2(
          v-if="selector && !selectorOnly && !entity.extra && isAddEnabled",
          x-small,
          fab,
          dark,
          depressed,
          color="primary",
          height="24",
          width="24",
          @click="create = !create",
        )
          v-icon(v-if="create")  mdi-magnify
          v-icon(v-else)  mdi-plus
      v-col.d-flex.justify-end(v-if="fromList", cols="auto")
        v-icon(@click="$emit('close', instance)")  mdi-close
    v-row.mb-5(v-if="entity && entity.description")
      v-col.py-0
        h4.font-weight-light {{ entity.description }}
    app-simple-entity-search(v-if="(!create || selectorOnly) && selector", v-bind="{ entity, disabled }", @input="setInstance")
    .entity-data(v-if="renderFields && shouldShowFields()")
      v-row
        //- [todo] override field labels with portal ones.
        v-col(cols="3", v-for="field in overridePortalFields")
          slot(:name="field.name", :field="field", :label="field.name", :type="field.type", :disabled="(field.disabled || disabled) || selectorOnly || (!create && showInfo) || $isGloballyDisabled(field)")
            foo-field(
              :entity="entity",
              :field="field",
              :label="$te(`${entity.name}.${field.name}`) ? $t(`${entity.name}.${field.name}`) : (field.label || field.name)",
              :type="$isFieldList(field, entity) ? 'list' : field.type",
              :value="getValue(field)",
              @input="input($event, field)",
              @change="input($event === null ? false : $event, field)",
              :disabled="(field.disabled || disabled) || selectorOnly || (!create && showInfo) || $isGloballyDisabled(field)",
              :items="$getFieldOptions(field, entity)",
              :inputValue="getValue(field)",
              :error-messages="errors[errorHash + '.' + field.name]",
            )
            //- .div {{ `${entity.name}.${field.name}` }}
      slot(name="addFields")
    v-row(v-if="chips && hasChips")
      v-col
        v-chip.mr-2(
          :color="r == relation.name ? '#3200e6' : 'lightgrey'"
          v-for="(relation, index) in relations.filter(r => !r.multiple && !r.extra)",
          @click="r = r === relation.name ? null: r = relation.name"
        )
          span
            span.relation--chip(:class="{'white--text': r === relation.name, 'black--text': r !== relation.name}") {{ $camelToString(relation.name) }}
      v-col(cols="12")
        v-card(flat, :class="{ invert: invert }", v-for="(relation, index) in relations")
          transition(mode="out-in", tag="div", name="fade", v-if="r === relation.name")
            .speech-bubble(:class="{ invert: invert }")
              app-entity-relation(
                :invert="!invert",
                @close="r = false",
                :path="path + '.' + relation.name",
                :parentPath="`${path}`",
                :relation="relation",
                :parent="entity",
                :parent-instance="instance",
                :entity="$findEntity(relation.type)",
                :selectorOnly="relation.selectorOnly ? true : false",
                :showInfo="showInfo || (relation.showInfo ? true : false)"
              )
    v-row(v-if="showExtraFields", v-for="group in extraFieldGroups")
      v-col(cols="12")
        h3.primary--text  {{ $camelToString($displayName(group.label)) || $camelToString($displayName(group.name)) }}
      v-col(cols="12").py-0
        h4.font-weight-light {{ group.description }}
      v-col(cols="3", v-for="field in $sortByUISequence(group.fields)")
        slot(:name="field.name", :label="field.name", :type="field.type")
        foo-field(
          :entity="group",
          :field="field",
          :label="field.label || field.name",
          :type="$isFieldList(field, group) ? 'list' : field.type",
          :value="getValue(field)",
          @change="input($event === null ? false : $event, field)",
          @input="input($event, field)",
          :inputValue="getValue(field)"
          :checked="getValue(field) === true",
          :disabled="field.disabled || disabled",
          :items="$getFieldOptions(field, group)",
          :errorMessages="errorInstance[errorHash + '.' + $displayName(group.name) + '.' + field.name]"
        )
</template>
<style type="text/css">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.invert.speech-bubble {
  background-color: #F1F1F5;
}

.relation--chip {
  font-size: 13px;
  font-weight: 800;
  font-family: "Avenir LT", "Roboto", sans-serif;
}
</style>
<script>
import EntityMixin from '@/mixins'
export default {
  name: 'entity',
  mixins: [EntityMixin],
  props: {
    extraData: {
      type: Boolean,
      default: true,
    },
    replasable: {
      type: Boolean,
      default: true,
    },
    chips: {
      type: Boolean,
      default: true,
    },
    invert: {
      type: Boolean,
      default: true,
    },
    selector: {
      type: Boolean,
      default: true,
    },
    selectorOnly: {
      type: Boolean,
      default: false,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
    path: {
      type: String,
      default: null
    },
    parentPath: {
      type: String,
      default: null
    },
    fromList: Boolean,
    parent: {
      type: Object,
      default: () => ({})
    },
    parentInstance: {
      type: Object,
      default: () => ({})
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isAddEnabled: {
      type: Boolean,
      default: true
    },
    relation: null,
    elementIndex: null,
  },
  data: function () {
    return {
      renderFields: true, // for re rendering
      r: null,
      // Invert the truth table so all previous cases become searcher
      // Add entity root and extra groups check to create
      create: (this.selectorOnly && !this.showInfo) || !this.selector || this.entity.extra,
    }
  },
  watch: {
    create: function(n,o) {
      this.rerender()
    }
  },
  computed: {
    extraFieldGroups() {
      return _.get(this.entity, 'fields', []).filter(f => f.extra && (!f.section || f.section === this.entityName) );
    },
    showExtraFields() {
      return this.extraData && !this.isExtraFieldGroup;
    },
    isExtraFieldGroup() {
      return Boolean(_.get(this.entity, 'extra'));
    },
    isRelation() {
      return Boolean(this.path);
    },
    entityName() {
      return _.get(this.entity, 'name');
    },
    hasChips() {
      return !_.isEmpty(this.relations.filter(r => !r.multiple && !r.extra));
    },
    getLabel() {
      const relationName = _.get(this.relation, 'name');
      const relationType = _.get(this.relation, 'type');
      const parentName = _.get(this.parent, 'name');
      const labelAttribute = relationType || this.entityName;

      if (this.modalInstance && !_.isEmpty(this.modalErrors)) {
        return this.$tCheckC(`${this.entityName}._name`, label, 1);
      }
      if (relationName && this.path) {
        const translated = this.$tCheckC(`${parentName}.${relationName}`, []);
        if (!_.isEmpty(translated)) return translated;
      }

      const label = this.$camelToString(this.$displayName(labelAttribute));
      return this.$tCheckC(`${labelAttribute}._name`, label, 1);
    },
    labelHash() {
      return (this.getLabel || '').replace(/\s/g, '');
    },
    extraLabelHash() {
      return this.$displayName(_.get(this.relation, 'name', _.get(this.entity, 'name')));
    },
    errorHash() {
      if(this.isExtraFieldGroup) return this.extraLabelHash;
      return this.path ? this.path : this.$lcfirst(this.entity.name);
    },
    errors() {
      return this.$store.state.errors;
    },
    portal() {
      return this.$store.state.portal;
    },
    sortedFields() {
      return this.$sortByUISequence(this.fields);
    },
    overridePortalFields() {
      // If the entity is not a Shipment type return the original fields.
      if (this.entityName !== 'Shipment') return this.sortedFields;

      const fieldsPortal = this.$fields(
        this.$findEntity(this.portal),
        'primitive'
      );

      if (fieldsPortal) {
        return this.$overrideFields(
          this.sortedFields,
          fieldsPortal,
          ['alias', 'name', 'label'],
        );
      }

      return this.sortedFields;
    },
    modalErrors() {
      return this.$store.state.modalErrors;
    },
    errorInstance() {
      return this.modalInstance && !_.isEmpty(this.modalErrors) ? this.modalErrors : this.errors;
    },
},
  methods: {
    shouldShowFields() {
      if (!this.create && !this.showInfo && !this.selectorOnly) return false
      if (!this.showInfo && this.selectorOnly) return false
      return true
    },
    rerender() {
      this.renderFields = false
      this.$nextTick(() => {this.renderFields = true});
    },
    setInstance(instance) {
      let entityState = (this.create ? 4 : _.get(this.parentInstance, 'entityState'));
      const { id } = instance;
      if (entityState === 3) {
        this.$store.commit(this.setInstancePathAction, { path: this.$getParentKey(this.parent, this.path), value: id })
      }
      this.$store.commit(this.setInstancePathAction, { path: this.path, value: instance })
      // re render the fields for showing info only after selection
      if (this.showInfo && (!this.create || this.selectorOnly)) {
        this.rerender()
      }
    },
    input ($event, field) {
      let fieldCopy = { ...field };
      fieldCopy.name = this.$lcfirst(fieldCopy.name)
      if (!fieldCopy.extra)
        this.$store.commit(this.setInstancePathAction, { path: this.path + '.' + fieldCopy.name, value: $event })
      else
        this.inputExtra($event, fieldCopy);
    },
    getValue(field) {
      if (!field.extra) return this.instance[this.$lcfirst(field.name)]
      return this.getExtraData(null, field, this.instance.extraData || []).value
    },
    inputExtra ($event, field) {
      var groupName = this.entity.name != null ? this.entity.name.replace(/(\_[\d]+)$/, '') : ''
      var extraData = this.instance.extraData || []
      var data = this.getExtraData($event, field, extraData)
      data.value = $event
      data.entityState = data.id ? 3 : 4
      data.groupName = groupName
      if (data.uid === undefined && !data.new) {
        data.new = true
        extraData.push(data)
      }
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.extraData', value: extraData });
    },
    getExtraData($event, field, extraData) {
      return extraData.find(e => Number(e.extraFieldId) === Number(field.extraFieldId)) || { type: field.type, value: $event, extraFieldId: field.extraFieldId, extraField: field }
    },
    setEntityState () {
      var entityState = (this.instance && this.instance.id) ? 3 : 4
      this.$store.commit(this.setInstancePathAction, {
        path: `${this.path}.entityState`,
        value: entityState
      });
    },
    setEntityName () {
      this.$store.commit(this.setInstancePathAction, {
        path: `${this.path}._Entity`,
        value: this.entity.name
      });
    },
  },
  created() {
    if(!this.entity.extra) {
      this.setEntityState()
      this.setEntityName()
    }
    if(this.entity.name === 'BusinessScope' && !this.instance.id) {
      this.$store.commit(this.setInstancePathAction, {
        path: `${this.path}`,
        value: _.get(this.$store, 'state.user.user.businessScope', {})
      })
    }
    this.r = ENV.ENTITIES[this.entity.name] && ENV.ENTITIES[this.entity.name].loadChipDefault;
  }
}
</script>
